import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { login, logout, refresh, signup } from './api'
import type { LoginParams } from './api'
import type { CreateUserParams } from '@/tygo/db'

export const authQueryOptions = (refreshToken: string) =>
  queryOptions({
    queryKey: ['auth'] as const,
    queryFn: () => refresh({ refresh_token: refreshToken }),
  })

export function useAuthQuery({ refreshToken }: { refreshToken: string }) {
  return useQuery({
    ...authQueryOptions(refreshToken),
    enabled: !!refreshToken,
    staleTime: 0,
  })
}

export function useSignupMutation() {
  const navigate = useNavigate()

  return useMutation({
    mutationFn: (input: CreateUserParams) => signup(input),
    onSuccess: () => {
      navigate({
        to: '/',
      })
    },
  })
}

export function useLoginMutation() {
  const navigate = useNavigate()

  return useMutation({
    mutationFn: (input: LoginParams) => login(input),
    onSuccess: () => {
      navigate({
        to: '/',
      })
    },
  })
}

export function useLogoutMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => logout(),
    onSuccess: () => {
      queryClient.clear() // Clear all cached queries
      window.location.href = '/'
    },
  })
}
